import { render, staticRenderFns } from "./RoomAvatar.vue?vue&type=template&id=a885e114&scoped=true&"
import script from "./RoomAvatar.vue?vue&type=script&lang=js&"
export * from "./RoomAvatar.vue?vue&type=script&lang=js&"
import style0 from "./RoomAvatar.vue?vue&type=style&index=0&id=a885e114&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a885e114",
  null
  
)

export default component.exports